import {PlayableMatchesStore, SKZTournament, SKZUser} from '@sdk-mobile';
import {H2H_CATEGORIES} from '@/services/internal/tournament/constants';
import type {TournamentCategory, TournamentType} from '@/services/internal/tournament/types';

export const isTournamentJoinable = async (tournament: SKZTournament) => {
  // TODO (websdk-ms-1-phase-play): mobile seems to use legacy joinable atm, please confirm
  // sdk-mobile/sdk-core/js/app/Utilities/MatchJoinController/MatchJoinController.tsx:2180

  const categories: TournamentCategory[] =
    await PlayableMatchesStore.fetchTournamentCategories(true);

  const exists = categories?.find((category) =>
    category.tournaments.find((t) => t.id === tournament.id)
  );

  return Boolean(exists);
};

export const isPooledLiquidity = (
  tournament: SKZTournament | SKZTournament[]
): tournament is SKZTournament[] => tournament instanceof Array;

const isCashTournament = (tournament: SKZTournament) =>
  Boolean(tournament.total_cash_prize > 0 || tournament.total_bonus_cash_prize > 0);

const determineTournamentCategory = (tournament: SKZTournament): TournamentType => {
  if (tournament.synchronous) {
    return 'SYNC';
  }
  if (tournament.live_event) {
    return 'LIVE';
  }

  if (tournament.bracket) {
    return 'BRACKET';
  }

  if (tournament.friend) {
    return 'FRIENDS';
  }

  if (isCashTournament(tournament)) {
    return 'CASH';
  }

  return 'Z';
};

const isH2H = (tournament: SKZTournament) =>
  H2H_CATEGORIES.includes(determineTournamentCategory(tournament));

export const isThreePlusH2H = (tournament: SKZTournament) =>
  isH2H(tournament) && tournament.maxPlayers > 2;

export const hasEnoughBalance = (tournament: SKZTournament, user?: SKZUser | null) => {
  const zBalance = user?.z_balance ?? 0;
  const cashBalance = user?.cash_balance ?? 0;
  const cashEntryFee = tournament.getCashEntryFee(); // Use discounted entry fee, if it exists

  const zBalanceLow = zBalance < tournament.z_fee;
  const cashBalanceLow = cashBalance < cashEntryFee;

  if (zBalanceLow || cashBalanceLow) {
    return false;
  }

  if (tournament.live_event) {
    if (
      tournament.entries_required > 0 &&
      (!tournament.live_event.entries ||
        tournament.live_event.entries < tournament.entries_required)
    ) {
      return false;
    }

    const tournamentStart = new Date(tournament.live_event.start);
    const now = new Date();
    if (tournamentStart > now && tournament.live_event.entries > 0) {
      // this.startLiveEventFlowForTournament(tournament, navigator, null, false);
      return false;
    }
  }

  return true;
};
